import Vue from 'vue';
import App from './App';
import router from './router';
import {vuexStore} from './store/index';

import VueSocketio from 'vue-socket.io';
// Vue.use(VueSocketio, 'http://195.169.146.42:8085');

// Vue.use(VueSocketio, 'http://195.169.146.42:8086');
Vue.use(VueSocketio, 'http://localhost:8086');

//require('./assets/css/bundle.min.css');

Vue.config.productionTip = false;

import VueResource from 'vue-resource';
Vue.use(VueResource);

//Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';

import VueTouch from 'vue-touch';
Vue.use(VueTouch);

import AudioManager from './plugins/AudioManager';
Vue.use(AudioManager);

import AnimationManager from './plugins/AnimationManager';
Vue.use(AnimationManager);

/* eslint-disable no-new */
new Vue({
    el: '#app',
	store : vuexStore,
    router,
    render: h => h(App),
    sockets:{
	    connect: function(){
	      console.log('socket connected')
	    },
	    customEmit: function(val){
	      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
	    }
	}
});




// WEBPACK FOOTER //
// ./src/main.js